import { createClient } from 'graphql-ws';
import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { config } from '@tools/ui/consts';
import { getAuthToken } from '@tools/ui-utils/auth.util';

const wsLink = new GraphQLWsLink(
  createClient({
    url: `${config.server.baseUrl}/graphql`.replace(/https?/, config.isLocalMode ? 'ws' : 'wss'),
    connectionParams: {
      authToken: getAuthToken(),
    },
  }),
);
const httpLink = new HttpLink({
  uri: `${config.server.baseUrl}/graphql`,
  credentials: 'include',
});
const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  const token = getAuthToken();
  return {
    headers: {
      ...headers,
      authorization: token,
    },
  };
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  authLink.concat(httpLink),
);

const cache = new InMemoryCache({
  addTypename: true,
});

export const client = new ApolloClient({
  link: splitLink,
  cache,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'ignore',
    },
  },
  resolvers: {},
  connectToDevTools: true,
});
